import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('voyageai'),
  titleToNamespace: true,
  avatarPath: avatars.voyageai,
  logoPath: logos.voyageai
});
